import * as types from '../../../constants/actionTypes';
// import * as auth from '../../../../tools/auth0.cred';
import * as api from '../../../tools/apiConfig';
// import jQuery from 'jquery';
import axios from 'axios';
// import constant from '../../../constants/constant'
// import { props.history.push } from '../../../store/configureStore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as url from '../../../tools/config';
import openSocket from 'socket.io-client';
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
const google = window.google;

export function signUpUser(signupdata) {
	return function (dispatch, getState) {
		axios.post(api.SIGN_UP_USER, JSON.stringify(signupdata), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.userData.success = true;
					return dispatch({ type: types.SIGN_UP_USER, userData: response.data.data.userData });
				}
				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.userData = {};
					response.data.data.userData.success = false;
					return dispatch({ type: types.SIGN_UP_USER, userData: response.data.data.userData ? response.data.data.userData : {} });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}


export function adminLogin(signindata, props) {
	return function (dispatch, getState) {
		axios.post(api.ADMIN_LOGIN, JSON.stringify(signindata), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					localStorage.setItem("token", response.data.data.token);
					localStorage.setItem("userId", response.data.data._id);
					localStorage.setItem('user', JSON.stringify(response.data.data));

					if (response.data.data.role_id.status == 3) {
						props.history.push("/superadmin-dashboard");
						toast.info(response.data.message);

					} else if (response.data.data.type == 'admin') {
						props.history.push("/admin-dashboard");
						toast.info(response.data.message)
					} else if (response.data.data.type == 'admin') {
						props.history.push("/admin-dashboard");
						toast.info(response.data.message)
					}
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				// toast.error(error);
			});
	}
}
export function logout(data, props) {
	return function (dispatch, getState) {
		axios.post(api.LOGOUT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info('Admin signed out successfully')
					if (data) {
						return dispatch({ type: types.LOG_OUT, appointmentsCount: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function addEmailTemplate(data, props) {
	return function (dispatch, getState) {
		// if (data.emailTemplateId) {
		// 	data.emailTemplateId =
		// }
		axios.post(api.ADD_EMAIL_TEMPLATE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				console.log("===>", response, props)
				if (response.data.code == 200) {

					props.history.push('/user/email-templates');
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.ADD_EMAIL_TEMPLATE, blogDetails: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function getEmailTemplateList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_EMAIL_TEMPLATES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// props.history.push('/user/email-templates');
					// toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.GET_EMAIL_TEMPLATES, emailTemplates: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function getEmailTemplateById(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_EMAIL_TEMPLATE_BY_ID, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				console.log("++++++++++++++RESPONSE+++++++++++", response)
				if (response.data.code == 200) {
					// props.history.push('/user/email-templates');
					// toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.GET_EMAIL_TEMPLATE_BY_ID, emailTemplates: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
				console.log("++++++++++++++error+++++++++++", error)
			});

	}
}

export function getPagesList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_PAGES_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				console.log("--------+++++++++++++++++>", response)
				if (response.data.code == 200) {
					// props.history.push('/user/email-templates');
					// toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.GET_PAGES_LIST, pages: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
				console.log("===============error===========++>>", error)
			});

	}
}

export function getPageById(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_PAGE_BY_ID, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_PAGE_BY_ID, pages: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function addEditPage(data, props) {
	return function (dispatch, getState) {
		axios.post(api.ADD_EDIT_PAGE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					props.history.push('/user/pages');
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.ADD_EDIT_PAGE, pageDetails: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function getLogsList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_LOGS_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// props.history.push('/user/email-templates');
					// toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.GET_LOGS_LIST, logs: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function getFeedbacksList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_FEEDBACKS_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_FEEDBACKS_LIST, feedbacks: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function updateFeedbackStatus(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.UPDATE_FEEDBACK_STATUS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (response.data.data.isSpecialistVerified == true || response.data.data.isPatientVerified == true) {
						toast.info('Feedback has been approved successfully');
					}
					else {
						toast.info('Feedback has been rejected successfully');
					}
					if (data.tab == 'SpecialistNA') {
						data.isSpecialistVerified = false;
					} else if (data.tab == 'PatientNA') {
						data.isPatientVerified = false;
					}
					axios.post(api.GET_FEEDBACKS_LIST, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								response.data.data.success = true;
								return dispatch({ type: types.GET_FEEDBACKS_LIST, feedbacks: response.data.data })
							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/user');
								toastr.error(response.data.message);
							}
						})
						.catch(function (error) { });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}


export function addDisputeContent(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.ADD_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info('Dispute added successfully')
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function addSubDisputeContent(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.ADD_SUB_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info('Dispute added successfully')
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function changeSpecialistType(data, props) {
	return function (dispatch, getState) {
		return dispatch({ type: types.CHANGE_SPECIALIST_TYPE, data })
	}
}
export function changeFeedbackType(data, props) {
	return function (dispatch, getState) {
		return dispatch({ type: types.CHANGE_FEEDBACK_TYPE, data })
	}
}


// export function forgotPassword(data, props) {
// 	return function (dispatch, getState) {
// 		axios.post(api.FORGOT_PASSWORD, JSON.stringify(data), {
// 			headers: {
// 				'Content-Type': 'application/json'
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					toast.info(response.data.message)
// 					setTimeout(function () {
// 						response.data.data.success = true;
// 						return dispatch({ type: types.FORGOT_PASSWORD, data: response.data.data });
// 					}, 3000)


// 				}
// 				else {
// 					toast.error(response.data.message)
// 					response.data.data = {};
// 					response.data.data.success = false;
// 					return dispatch({ type: types.FORGOT_PASSWORD, data: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 				toast.error(error);
// 			});
// 	}
// }

// export function resetPassword(data, props) {
// 	return function (dispatch, getState) {
// 		axios.post(api.RESET_PASSWORD, JSON.stringify(data), {
// 			headers: {
// 				'Content-Type': 'application/json'
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					toast.info(response.data.message);
// 					response.data.data.success = true;
// 					return dispatch({ type: types.RESET_PASSWORD, data: response.data.data });
// 				}
// 				else {
// 					toast.error(response.data.message);
// 					response.data.data = {};
// 					response.data.data.success = false;
// 					return dispatch({ type: types.RESET_PASSWORD, data: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 				toast.error(error);
// 			});
// 	}
// }

// export function activateAccount(data, props) {
// 	return function (dispatch, getState) {
// 		axios.post(api.ACTIVATE_ACCOUNT, JSON.stringify(data), {
// 			headers: {
// 				'Content-Type': 'application/json'
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					toast.info(response.data.message);
// 					response.data.data.success = true;
// 					return dispatch({ type: types.ACTIVATE_ACCOUNT, data: response.data.data });
// 				}
// 				else {
// 					toast.error(response.data.message);
// 					response.data.data.success = false;
// 					return dispatch({ type: types.ACTIVATE_ACCOUNT, data: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 				toast.error(error);
// 			});
// 	}
// }


// export function changeEmail(data, props) {
// 	return function (dispatch, getState) {
// 		axios.post(api.CHANGE_EMAIL, JSON.stringify(data), {
// 			headers: {
// 				'Content-Type': 'application/json'
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					toast.info(response.data.message);
// 				}
// 				else {
// 					toast.error(response.data.message);
// 				}
// 			})
// 			.catch(function (error) {
// 				toast.error(error);
// 			});
// 	}
// }

export function changeSearchedDate(data, props) {
	return function (dispatch, getState) {
		return dispatch({ type: types.CHANGE_SEARCHED_DATE, data });
		}
}
